import { Badge, HStack } from '@chakra-ui/react';
// local imports
import { TextValue } from './DiffNumber';

type DiffLinkedElementCountProps = {
  newElements: Array<string>;
  oldElements: Array<string>;
  currentIds: Array<string> | undefined;
  onClick?: () => void;
};

export function DiffLinkedElementCount({
  newElements,
  oldElements,
  currentIds,
  onClick,
}: DiffLinkedElementCountProps) {
  const newSet = new Set(newElements);
  const oldSet = new Set(oldElements);
  const currentSet = new Set(currentIds ?? []);

  const onlyInNew = [...newSet].filter((newElement) => !oldSet.has(newElement));
  const onlyInOld = [...oldSet].filter((oldElement) => !newSet.has(oldElement));

  const oldCount = onlyInOld.length;
  const newCount = onlyInNew.length;
  const linkedElementCount = currentSet.size;

  return (
    <HStack spacing={2} align="center">
      <TextValue value={linkedElementCount} onClick={onClick} />
      <HStack spacing={1}>
        {newCount > 0 && (
          <Badge
            colorScheme="green"
            textTransform={'none'}
            size="xs"
            fontSize={'xs'}
            borderRadius={'md'}
          >
            +{newCount}
          </Badge>
        )}
        {oldCount > 0 && (
          <Badge
            colorScheme="red"
            textTransform={'none'}
            size="xs"
            fontSize={'xs'}
            borderRadius={'md'}
          >
            -{oldCount}
          </Badge>
        )}
      </HStack>
    </HStack>
  );
}
